"use strict";
/* globals module */
/**
 * @module calendarEventStatusClient
 * @description  CalendarEventStatusClient provides an easy way to consume CalendarEventStatus REST API end-points. In order to obtain needed routes `calendarEventStatusClient` uses `calendarEventStatusRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CalendarEventStatusClient = /** @class */ (function () {
    function CalendarEventStatusClient(calendarEventStatusBatchClient, calendarEventStatusRoute, apiClient) {
        this.calendarEventStatusBatchClient = calendarEventStatusBatchClient;
        this.calendarEventStatusRoute = calendarEventStatusRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventStatusClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventStatusRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEventStatusClient.prototype, "batch", {
        get: function () {
            return this.calendarEventStatusBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventStatus resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventStatusClient.find({
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: <identifiers>,
                    from: <start-date>,
                    to: <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventStatus resource.
     * @method
     * @param id CalendarEventStatus id which uniquely identifies CalendarEventStatus resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventStatusClient.get()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create CalendarEventStatus action has been performed; this action creates a new CalendarEventStatus resource.
     * @method
     * @param data A CalendarEventStatus object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventStatus action has been performed.
     * @example calendarEventStatusClient.create({
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventStatus action has been performed. This action updates a CalendarEventStatus resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventStatus);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventStatus object used to update specified CalendarEventStatus resource.
     * @returns A promise that is resolved once the update CalendarEventStatus action has been performed.
     * @example calendarEventStatus is a resource previously fetched using get action.
                calendarEventStatus.name = '<name>';
                calendarEventStatusClient.update(calendarEventStatus)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a CalendarEventStatus resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventStatus);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventStatus object used to delete specified CalendarEventStatus resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventStatus is a resource previously fetched using get action.
                calendarEventStatusClient.remove(calendarEventType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventStatus resources from the system if succesfully completed.
     * @method
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarEventStatusClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c;
    CalendarEventStatusClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventStatusBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventStatusRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventStatusBatchClient !== "undefined" && __1.CalendarEventStatusBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarEventStatusRoute !== "undefined" && __1.CalendarEventStatusRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarEventStatusClient);
    return CalendarEventStatusClient;
}());
exports.CalendarEventStatusClient = CalendarEventStatusClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 
